import { CopyBlock } from '@/design-system/molecules/CopyBlock';
import { generateStyleModifiers } from '@/utils/generateStyleModifiers';

const IntegrationCopyBlock = (props) => {
    const modifiers = generateStyleModifiers(props.appliedCssClassNames);

    return (
        <CopyBlock
            {...props}
            isToppedAlign={modifiers.alignment === 'top'}
            isRightAlign={modifiers.alignment === 'right'}
            isLeftAlign={modifiers.alignment === 'left'}
            isLargeImage={modifiers.imageSize === 'large'}
        />
    );
};

export default IntegrationCopyBlock;
